import { useSeo } from "../lib/seo";
import { Lines } from "../components/motion";
import { Cta } from "../components/ui-bits";

export default function NotFound() {
  useSeo("Pagina non trovata", "La pagina che cerchi non esiste o è stata spostata.");
  return (
    <section className="flex min-h-[80vh] flex-col justify-center px-5 pt-32 sm:px-10 lg:px-16" data-testid="not-found">
      <p className="eyebrow">Errore 404</p>
      <Lines as="h1" onLoad delay={0.5} lines={["Questa pagina", "non è nel nostro racconto."]} className="mt-8 text-4xl leading-[1.08] sm:text-6xl" />
      <div className="mt-12"><Cta to="/">Torna alla home</Cta></div>
    </section>
  );
}
